import { FileHandlePlugin, FileHandler, type FileHandlerOptions } from "@tiptap/extension-file-handler"
import { PluginKey } from "@tiptap/pm/state"

import { sdk } from "../../../sdk"
import { IssueTypeAttachmentNode } from "../../nodes"

interface IssueTypeFileHandlerOptions extends Pick<FileHandlerOptions, "allowedMimeTypes"> {
	uuid: string
}

export const IssueTypeFileHandler = FileHandler.extend<IssueTypeFileHandlerOptions>({
	name: "IssueTypeFileHandler",
	addProseMirrorPlugins() {
		return [
			FileHandlePlugin({
				key: new PluginKey(this.name),
				editor: this.editor,
				allowedMimeTypes: this.options.allowedMimeTypes,
				onDrop: async (editor, files, pos) => {
					const [offlineAttachments, _promise] = await sdk.issueTypeAttachments.bulkAdd(
						files.map((file) => ({
							issue_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContentAt(
							pos,
							offlineAttachments.map((offlineAttachment) => ({
								type: IssueTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
				onPaste: async (editor, files, _htmlContent) => {
					const [offlineAttachments, _promise] = await sdk.issueTypeAttachments.bulkAdd(
						files.map((file) => ({
							issue_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContent(
							offlineAttachments.map((offlineAttachment) => ({
								type: IssueTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
			}),
		]
	},
})
